import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import menuIcon from '../media/menu.png';

const navLinks = [
  { to: '/', label: 'Inicio' },
  { to: '/about', label: 'Nosotros' },
  { to: '/services', label: 'Servicios' },
  { to: '/contact', label: 'Contacto' },
];

/**
 * Navegación principal. La usan tanto el hero del home como el header de las
 * páginas internas.
 *
 * En móvil el CSS oculta la lista y deja el botón de hamburguesa. Ese botón era
 * un <img> suelto, sin estado ni manejador: se veía pero no abría nada, así que
 * en celular el sitio quedaba sin forma de navegar.
 */
const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="mainNav" aria-label="Navegación principal">
      <ul className={isMenuOpen ? 'mainNavList mainNavListOpen' : 'mainNavList'}>
        {navLinks.map(({ to, label }) => (
          <li key={to}>
            {/* `end` evita que "Inicio" quede marcado como activo en todas las
                rutas, ya que "/" es prefijo de cualquier otra. */}
            <NavLink to={to} end={to === '/'} onClick={closeMenu}>
              {label}
            </NavLink>
          </li>
        ))}
      </ul>

      <button
        type="button"
        className="navMenu"
        aria-expanded={isMenuOpen}
        aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
        onClick={() => setIsMenuOpen((open) => !open)}
      >
        <img src={menuIcon} alt="" />
      </button>
    </nav>
  );
};

export default Nav;
